import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { focusElemnt } from '../../../../common/helper'
import moment from 'moment'
import { pickUpDropoffColumnDefs, pickUpDropoffColumnDefs2 } from './PIckUpAndDropoffConstant'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const ReportTable = (props) => {
    const { reportData,coloumndef=0 } = props
    const { translations } = useTranslation()
    const gs = translations?.generalSettings || {}
    const tr = (key, fallback) => gs?.[key] || fallback

    const [tableData, setTableData] = useState([])
    const [searchData, setSearchData] = useState({
        CompanyName: "",
        BranchName: "",
        Cityname: "",
        Statename: "",
        ChargeTypeName: "",
        RangeMin: "",
        RangeMax: "",
        Charge: "",
        UserName: "",
    })
    const columnDefs = pickUpDropoffColumnDefs.map((col) => ({ ...col, headerName: tr(col.translationKey, col.headerName) }))
    const columnDefs2 = pickUpDropoffColumnDefs2.map((col) => ({ ...col, headerName: tr(col.translationKey, col.headerName) }))
    const tableCloumns = coloumndef===0?columnDefs:columnDefs2;
    useEffect(() => {
        setTableData(sortingData(reportData))
        setSearchData({
            CompanyName: "",
            BranchName: "",
            Cityname: "",
            Statename: "",
            ChargeTypeName: "",
            RangeMin: "",
            RangeMax: "",
            Charge: "",
            UserName: "",
        })
    }, [reportData])
    const sortingData = (data) => {
        return data.sort((a, b) => a.CompanyName.localeCompare(b.CompanyName)).sort((a, b) => a.BranchName.localeCompare(b.BranchName)).sort((a, b) => a.Cityname.localeCompare(b.Cityname))
    }
    const keyboardNavigation = (event, prevId, nextId) => {
        if (event.key === 'Escape') {
            focusElemnt(prevId)
        }
        if (event.key === 'Enter') {
            focusElemnt(nextId)
        }
    }
    const handleSearchData = (event, field) => {
        setSearchData({ ...searchData, [field]: event.target.value.toString() })
    }
    useEffect(() => {
        let fiterData = reportData.filter((val) => (searchData.BranchName === "" || val.BranchName.toLowerCase().includes(searchData.BranchName.toLowerCase())) &&
            (searchData.Cityname === "" || val.Cityname.toLowerCase().includes(searchData.Cityname.toLowerCase())) &&
            (searchData.CompanyName === "" || val.CompanyName.toLowerCase().includes(searchData.CompanyName.toLowerCase())) &&
            (searchData.Statename === "" || val.Statename.toLowerCase().includes(searchData.Statename.toLowerCase())) &&
            (searchData.ChargeTypeName === "" || val.ChargeTypeName.toLowerCase().includes(searchData.ChargeTypeName.toLowerCase())) &&
            (searchData.RangeMin === "" || val.RangeMin.toString().includes(searchData.RangeMin.toString())) &&
            (searchData.RangeMax === "" || val.RangeMax.toString().includes(searchData.RangeMax.toString())) &&
            (searchData.Charge === "" || val.Charge.toString().includes(searchData.Charge.toString())) &&
            (searchData.UserName === "" || val.UserName.toLowerCase().includes(searchData.UserName.toLowerCase()))
        )
        setTableData(fiterData)
    }, [searchData])

    const TableRow1 = ({ val, index }) => {
      return (
        <TableRow key={`DR-${index}`}>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{index + 1}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '200px' }}>
            {val.CompanyName}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '190px' }}>
            {val.BranchName}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '107px' }}>
            {val.Cityname}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '100px' }}>
            {val.Statename}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>{val.ChargeTypeName}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMin}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.RangeMax}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444' }}>{val.Charge}</TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '106px' }}>
            <Tooltip
              title={`${val.UserName}(${val.UserBranch})`}
              PopperProps={{
                sx: {
                  '& .MuiTooltip-tooltip': {
                    backgroundColor: '#DAEDFE',
                    color: '#000',
                    minHeight: '26px',
                    display: 'flex',
                    fontWeight: '400',
                    alignItems: 'center',
                    marginTop: '5px !important',
                    fontSize: '12px',
                  },
                },
              }}
              placement="bottom-start"
            >
              <span
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  display: 'block',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
                onMouseOut={(e) => (e.currentTarget.style.color = '#444')}
                onMouseOver={(e) => (e.currentTarget.style.color = '#0086FF')}
              >
                {val.UserName}
              </span>
            </Tooltip>
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
            {moment(val.ModifiedDate).format('HH:mm, DD-MMM-YY')}
          </TableCell>
          <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
            <Checkbox checked={val.IsActive == 1 ? true : false} sx={{ padding: 0 }} />
          </TableCell>
        </TableRow>
      )
    }
    const TableRow2 = ({ val, index }) => {
      return (
        <TableRow key={`DR-${index}`}>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{index + 1}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '190px' }}>
                                {val.BranchName}
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '107px' }}>
                                {val.Cityname}
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', }}>{val.ChargeTypeName}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMin}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMax}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMin}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.RangeMax}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.Charge}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'right', fontSize: '12px', color: '#444', }}>{val.Charge}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', maxWidth: '106px' }}>
                                <Tooltip title={`${val.UserName}(${val.UserBranch})`}
                                    PopperProps={{
                                        sx: {
                                            "& .MuiTooltip-tooltip": {
                                                backgroundColor: '#DAEDFE',
                                                color: "#000",
                                                minHeight: '26px',
                                                display: 'flex',
                                                fontWeight: '400',
                                                alignItems: "center",
                                                marginTop: '5px !important',
                                                fontSize: '12px'
                                            }
                                        }
                                    }}
                                    placement="bottom-start">
                                    <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: "underline" }}
                                        onMouseOut={(e) => e.currentTarget.style.color = '#444'}
                                        onMouseOver={(e) => e.currentTarget.style.color = '#0086FF'}
                                    >
                                        {val.UserName}
                                    </span>
                                </Tooltip>
                            </TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444', }}>{moment(val.ModifiedDate).format("HH:mm, DD-MMM-YY")}</TableCell>
                            <TableCell sx={{ minHeight: '36px', textAlign: 'left', fontSize: '12px', color: '#444' }}>
                                <Checkbox
                                    checked={val.IsActive == 1 ? true : false}
                                    sx={{ padding: 0, }}
                                />
                            </TableCell>
                        </TableRow>
      )
    }
    return (
      <TableContainer component={Paper} className="scrollBlue" style={{ maxHeight: '60vh', marginBottom: '5px' }}>
        <Table
          stickyHeader
          size="small"
          aria-label="a dense table"
          sx={{
            '& .MuiTableCell-root': {
              padding: '6px 8px !important',
            },
          }}
        >
          <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
            <TableRow>
              {tableCloumns.map((col, index) => (
                <TableCell
                  key={`TH-${index}`}
                  sx={{
                    ...col.headerSx,
                    backgroundColor: '#DAEDFE',
                    minHeight: '40px',
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#444',
                  }}
                >
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
            <TableRow>
              {tableCloumns.map((col, index) =>
                col.showfilter ? (
                  <TableCell key={`FTH-${index}`} sx={{ minHeight: '36px' }}>
                    <div className="filter-input" style={{ fontSize: '12px', justifyContent: 'space-between' }}>
                      <input
                        id={`index-${index}`}
                        className="field"
                        name="cancelSearchInput"
                        style={{ width: '100%' }}
                        value={searchData[col.field]}
                        placeholder={tr('gsContains', 'Contains')}
                        onChange={(e) => handleSearchData(e, col.field)}
                        onKeyDown={(e) =>
                          keyboardNavigation(
                            e,
                            index === 1 ? 'editExisting' : `index-${index - 1}`,
                            index === 9 ? 'Select_Charge' : `index-${index + 1}`
                          )
                        }
                      />
                      <FilterAltIcon sx={{ paddingRight: '0px !important' }} />
                    </div>
                  </TableCell>
                ) : (
                  <TableCell></TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.map((val, index) => {
             return  coloumndef === 0 ? <TableRow1 val={val} index={index} /> : <TableRow2 val={val} index={index} />
              
            })}
            
          </TableBody>
        </Table>
      </TableContainer>
    )
}

export default ReportTable